/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import NewSelectInput from "../../../components/NewSelectInput";
import TextareaField from "../../../components/common/TextareaField";
import { useState } from "react";

const BulkForwardModal = () => {
  const [awbText, setAwbText] = useState("");

  return (
    <div className="w-full py-4 pr-2 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
      <div className="p-4 space-y-4">
        <NewSelectInput
          label="Select 3PL Company"
          name={""}
          selectOptions={[]}
        />
        <NewSelectInput label="Select Warehouse" name={""} selectOptions={[]} />
      </div>
    </div>
  );
};

export default BulkForwardModal;
